import React from "react";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";
import { withTranslation } from "react-i18next";

const fields = [
  {
    name: "Salutation",
    key: "salutation",
    renderField: (value) => getOptionLabel("salutationOptions", value) || "-",
    isRequired: true,
  },
  {
    name: "First Name",
    key: "firstName",
    isRequired: true,
  },
  {
    name: "Middle Name",
    key: "middleName",
    isRequired: false,
  },
  {
    name: "Last Name",
    key: "lastName",
    isRequired: true,
  },
  {
    name: "Mobile Number",
    key: "mobileNumber",
    isRequired: true,
  },
  {
    name: "Land Line",
    key: "landLine",
    isRequired: false,
  },
  {
    name: "Email",
    key: "email",
    isRequired: true,
  },
  {
    name: "Designation",
    key: "designation",
    isRequired: false,
  },
];

const AuthorizedPersonDetailsView = ({
  authorizedPerson,
  isExpandable = true,
  t,
}) => {
  return (
    <Collapse title="Authorized Person Info" isExpandable={isExpandable}>
      <Row className="d-flex  mb-2 ">
        {fields.map(({ name, key, isRequired, renderField }) => {
          const value = get(authorizedPerson, key, "");

          return (
            <Col key={key} lg={6} className="mb-1">
              <Row>
                <Col md={5}>{t(name)}:</Col>
                <Col
                  md={7}
                  className="fw-semibold"
                  style={{ wordBreak: "break-word" }}
                >
                  {renderField
                    ? renderField(value)
                    : get(authorizedPerson, key, null) ??
                      (isRequired ? "-" : "N/A")}
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Collapse>
  );
};

AuthorizedPersonDetailsView.propTypes = {
  authorizedPerson: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(AuthorizedPersonDetailsView);
